/**
 * kisiKunyeGonder.js — a COMPANY's phone / e-mail change of a worker, sent so that its pending Edit Kişi Request survives (backlog #749, re-opened).
 *
 * The backend replaces the company's earlier pending request for the person with the new one instead of merging, and the company sends one key per
 * PATCH, so a second change (phone, then e-mail) used to withdraw the first. Here a company login first reads its own pending request for the person
 * (fresh, not the card's remembered one) and lets that request's other field ride along (kisiDuzenlemeTalebiService.govdeyeBekleyeniEkle). Staff
 * never create requests — their PATCH writes at once — so for a staff login nothing is read or added: the body goes as it is.
 * If the combined PATCH was written at once (the card turned out to be open: 200) the carried request is redundant and is withdrawn (best effort).
 * A failed read of the pending request just sends the change as it was (the old behaviour).
 */
import { patchKunye } from './kisiKunyeService';
import {
  geriCekTalep, getDuzenlemeTalepleri, govdeyeBekleyeniEkle, talepGonderildi, TALEP_DURUMU,
} from './kisiDuzenlemeTalebiService';
import { isFirmaAccount } from './firmaSessionService';

/** Resolves kisiKunyeService.patchKunye's result. */
export async function kunyeyiGonder(personId, govde) {
  if (!isFirmaAccount()) return patchKunye(personId, govde);
  let bekleyen = null;
  try {
    const d = await getDuzenlemeTalepleri({ durum: TALEP_DURUMU.BEKLIYOR, personId, size: 1 });
    bekleyen = (d?.talepler || [])[0] || null;
  } catch {
    bekleyen = null;
  }
  const { govde: gonderilecek, tasinan } = govdeyeBekleyeniEkle(govde, bekleyen);
  const sonuc = await patchKunye(personId, gonderilecek);
  if (tasinan && !talepGonderildi(sonuc)) {
    try { await geriCekTalep(tasinan.id); } catch { /* the change is written; a leftover pending note is only untidy */ }
  }
  return sonuc;
}
